import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const PrivateRoute = ({ children }) => {
  const { currentUser, churchUser, loading } = useAuth();

  // Se ainda está carregando, não redireciona
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
        }}
      >
        Verificando autenticação...
      </div>
    );
  }

  // Exige tanto Firebase Auth quanto validação contra coleção membros
  return (currentUser && churchUser) ? <>{children}</> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
